import axios from "axios";
import CcoSecurity from "./CcoSecurity";
import DeviceInfo from "./deviceInfo";
import { sign } from './jr-aks';
const errorMap = {};
const ERROR_SUCCESS = 0;
const ERROR_REQUIRE_LOGIN = 3;

class ErrorInfo extends Error {
  constructor(code, msg) {
    super(msg);
    this.code = parseInt(code);
    this.msg = msg;
  }

  equalTo(code) {
    return this.code === parseInt(code);
  }

  toString() {
    return `#${this.code},${this.msg}`;
  }
}

export class Http {
  constructor(config) {
    if (config === null) throw new Error("请添加配置信息");

    this.config = config;
  }

  publicKeyRes = null;
  config = {
    baseApi: "",
    headers: {},
  };
  requiredToLogin = false;

  // 接口默认配置
  apiConfig = {
    common: false, // 是否增加公参
    sign: false, // 是否增加验签
    deviceInfoType: 1, // deviceInfo 1: 字符串 2: 对象
    security: false,
    appId:''
  };

  post(url, form, returnOriginData = false, apiConfig) {
    return this.request(url, "post", form, returnOriginData, apiConfig);
  }

  get(url, params, returnOriginData = false, apiConfig) {
    return this.request(url, "get", params, returnOriginData, apiConfig);
  }

  postJson(url, params) {
    return this.request(url, "json", params);
  }

  async request(
    url,
    method = "get",
    payload = {},
    returnOriginData = false,
    apiConfig = {}
  ) {
    apiConfig = Object.assign({}, this.apiConfig, apiConfig);

    payload = payload || {};

    // 参数
    let params = {
      reqData: payload,
    };
    // 新网关加密防重
    if (apiConfig.security && apiConfig.appId) {
      let append = await dealwithParams(payload);
      params = Object.assign(params, append);
      async function dealwithParams(reqData) {
        // const aar = new AAR2(); // 1，new对象
        // const gateWaySignData = JSON.stringify(reqData);
        // const gateWayNonce = aar.nonce(); // 2，产生nonce
        // const gateWaySignature = aar.sign(gateWaySignData, gateWayNonce);
        // const aarData = {
        //   nonce: gateWayNonce,
        //   signature: gateWaySignature,
        // };
        let aarSignData = await sign(JSON.stringify(reqData))
        let aarData = {
          nonce: aarSignData.nonce,
          signature: aarSignData.signature,
        }
        const securityData = await CcoSecurity.getPSign(apiConfig.appId).sign(
          JSON.parse(JSON.stringify(reqData))
        );
        const timestamp = new Date().getTime();
        const ccoData = {
          client: "h5",
          clientVersion: "1.0.0",
          t: timestamp,
          h5st: securityData.h5st,
          _stk: securityData._stk,
        };
        return {
          cco: JSON.stringify(ccoData),
          aar: JSON.stringify(aarData),
          eid: JSON.stringify(DeviceInfo.getDeviceInfo() || {})
        };
      }
    }

    let config = this.config;
    method = method.toLowerCase();
    let options = {
      headers: config.headers || {},
      url,
      baseURL: config.baseURL,
      withCredentials: true,
      timeout: 6000,
    };
    if (method === "post") {
      options.data = params;
      options.method = "POST";
      options.headers["Content-Type"] = "application/x-www-form-urlencoded";
      options.transformRequest = [formRequestEncode];
    } else if (method === "json") {
      options.data = payload;
      options.method = "POST";
      options.headers["Content-Type"] = "application/json";
    } else if (method === "get") {
      options.method = "GET";
      options.params = params;
    }
    //options.headers['x-requested-with'] = 'XMLHttpRequest';
    return new Promise((resolve, reject) => {
      axios.request(options).then(
        (res) => {
          let { resultCode, channelEncrypt, resultMsg, resultData } = res.data;
          resultCode = parseInt(resultCode);
          if (resultCode === ERROR_SUCCESS) {
            if (returnOriginData) {
              resolve(
                resultData || { success: false, msg: "resultData 未定义" }
              );
            } else {
              if (resultData) {
                if (
                  resultData.hasOwnProperty("success") &&
                  !resultData.success
                ) {
                  reject(resultData);
                } else {
                  resolve(resultData);
                }
              } else {
                reject(resultMsg);
              }
            }
          } else if (
            !this.requiredToLogin &&
            resultCode === ERROR_REQUIRE_LOGIN
          ) {
            //多个请求都要求要登录的时候可能出现次多次跳转到登录的情况
            this.requiredToLogin = true;
            let currentHref = window.location.href;
            window.location.href = 'https://plogin.m.jd.com/user/login.action?appid=1&returnurl=' + encodeURIComponent(currentHref)
            this.requiredToLogin = false;
          } else {
            reject(res.data);
            console.error(
              "接口系统错误>>：" +
                JSON.stringify({ url: res.request.responseURL, ...res.data })
            );
            // IPage.goErrorPage(res.data);
          }
        },
        (req) => {
          let err;
          if (req instanceof Error) {
            err = req;
          } else if (req && req.request && req.request.status)
            err = new ErrorInfo(
              req.request.status,
              `网络状态异常(${req.request.status})`
            );
          else err = new ErrorInfo(-1, req.toString());

          reject(err);
          // IPage.goErrorPage(err);
        }
      );
    });
  }
}

const httpIns = {};

export function createHttp(config) {
  if (!config.baseURL) return null;

  if (typeof httpIns[config.baseURL] === "undefined")
    httpIns[config.baseURL] = new Http(config);

  return httpIns[config.baseURL];
}

function formRequestEncode(formData) {
  let { reqData } = formData;
  formData.reqData = JSON.stringify(reqData);
  return cvtToUrlQuery(formData);
}

function reportError(error) {
  console.error(error.toString());
}

function cvtToUrlQuery(obj) {
    let ret = '';
    if (typeof obj === 'object' && obj !== null) {
        Object.keys(obj).map(propKey => {
            let val = obj[propKey];
            ret += propKey + '=' + encodeURIComponent(val) + '&'
        });

        if (ret.length > 0)
            ret = ret.substring(0, ret.length - 1);
    }
    return ret;
}